<template>
  <form-section>
    <p class="item-description">
      {{ $t('Integrations_Segment_Text_TokenInfo') }}
    </p>

    <integration-token-box :token="model.token" />

    <br />

    <p class="item-description">
      {{ $t('Integrations_Segment_Text_EndpointsInfo') }}
    </p>

    <el-table :data="tableData" stripe>
      <el-table-column
        prop="api"
        :label="$t('Integrations_Segment_Text_EndpointType')"
        width="180"
      />
      <el-table-column
        prop="endpoint"
        :label="$t('Integrations_Segment_Text_Endpoint')"
      />
    </el-table>
  </form-section>
</template>

<script>
import FormSection from '@/common/components/form/FormSection'
import IntegrationTokenBox from '@/modules/integrations/components/IntegrationTokenBox'

export default {
  name: 'SegmentOverview',

  components: {
    FormSection,
    IntegrationTokenBox
  },

  props: {
    model: {
      required: false
    }
  },

  computed: {
    tableData() {
      let apiEndpoint = this.$store.state.app.domains.api
      return [
        {
          api: this.$t('Integrations_ApiEndpoint'),
          endpoint: `https://${apiEndpoint}`
        }
      ]
    }
  }
}
</script>

<style scoped>
.item-description {
  color: #808080;
  font-size: 12px;
  line-height: 18px;
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/modules/integrations/types/segment/SegmentOverview.vue